module.exports = __webpack_public_path__ + "img/esquemaH.cc694399.svg";